















































































































import { Component, Vue, Ref } from "vue-property-decorator";
import { ValidationObserver } from "vee-validate";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import { usuarioService } from "@/service/usuario/UsuarioService";

@Component({
  components: {
    GsModalDialog,
  },
})
export default class DefinirNovaSenha extends Vue {
  @Ref("definirSenhaObserver")
  definirSenhaObserver!: InstanceType<typeof ValidationObserver>;

  novaSenha = "";
  confirmaNovaSenha = "";
  loading = false;

  /* MODAL */
  showDialog = false;
  successDialog = false;
  dialogTitle = "";
  dialogMessage = "";

  definirNovaSenha() {
    this.loading = true;
    usuarioService
      .resetarSenha(this.$route.params.token, this.novaSenha)
      .then(() => {
        this.openDialog(true);
      })
      .catch((err: any) => {
        console.error(err);
        this.openDialog(false);
      });
  }

  closeDialog() {
    this.showDialog = false;
    if (this.successDialog) {
      this.$router.replace({ name: "Login" });
    }
  }

  openDialog(success: boolean) {
    this.loading = false;
    this.successDialog = success;
    if (success) {
      this.dialogTitle = "Sucesso";
      this.dialogMessage = "Nova senha cadastrada com sucesso.";
    } else {
      this.dialogTitle = "Erro";
      this.dialogMessage = "Ocorreu um erro ao tentar redefinir a senha. Entre em contato com a Gente Serviços.";
    }
    this.showDialog = true;
  }

  get btnColor() {
    return this.successDialog ? "#00CD96" : "error";
  }

  get btnText() {
    return this.successDialog ? "Ok, entendi" : "Fechar";
  }

  get dialogImg() {
    return this.successDialog ? "success.png" : "error.png";
  }
}
